/* template */
<template minapp="mpx" xlang="wxml"><contact-dialog :show="(show)" title="温馨提示" cancelText="我知道了" content="儿童不能单独出行，请选择一名成年乘客同行" @cancel="cancelContactDialog" btnStyle="fill"></contact-dialog></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m24b6b904"}'>
  
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m24b6b904"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./child-dialog.mpx.js?isComponent&outputPath=components%2Fchild-dialog24b6b904%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./child-dialog.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fchild-dialog24b6b904%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m24b6b904"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/child-dialog24b6b904/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'contact-dialog':getComponent(require("./index.mpx?isComponent&outputPath=components%2Findexd3416d8a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
